import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import AgentForm from "@/components/AgentForm";
import { fetchClient } from "@/lib/api";
import { getAgentBlueprints } from "@/lib/formOptions";
import type { SerializedIntegration, FormOption } from "@/types";

export const Route = createFileRoute("/dashboard/clients/$id/agents/new")({
  component: CreateAgentPage,
});

function CreateAgentPage() {
  const { id } = Route.useParams();
  return <CreateAgentPageComponent businessId={id} />;
}

// Exported for testing
export function CreateAgentPageComponent({
  businessId,
}: {
  businessId: string;
}) {
  const navigate = useNavigate();
  const [integrations, setIntegrations] = useState<SerializedIntegration[]>([]);
  const [blueprints, setBlueprints] = useState<FormOption[]>([]);

  useEffect(() => {
    let active = true;
    fetchClient(businessId)
      .then((response) => {
        if (!active) return;
        setIntegrations(response.integrations || []);
      })
      .catch((error) => {
        if (!active) return;
        console.error("Error fetching client integrations:", error);
      });
    return () => {
      active = false;
    };
  }, [businessId]);

  useEffect(() => {
    let active = true;
    getAgentBlueprints()
      .then((options) => {
        if (!active) return;
        setBlueprints(options);
      })
      .catch((error) => {
        if (!active) return;
        console.error("Error fetching agent blueprints:", error);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <EntityFormPage
      title="Create Agent"
      description="Add a new chat or voice agent for this client."
      backHref={`/dashboard/clients/${businessId}`}
    >
      <AgentForm
        businessId={businessId}
        integrations={integrations}
        blueprints={blueprints}
        onSaved={() =>
          navigate({
            to: "/dashboard/clients/$id",
            params: { id: businessId },
          })
        }
      />
    </EntityFormPage>
  );
}
